document.addEventListener('DOMContentLoaded', function() {
  // Elements for account drawer and buttons
  const accountButtonDesktop = document.getElementById('account-icon-button');
  const accountButtonMobile = document.getElementById('account-button');
  const accountDrawer = document.getElementById('account-menu-drawer');
  const closeButton = document.getElementById('close-drawer-button');

  // Elements for forms and links
  const loginForm = document.getElementById('login-form');
  const recoverForm = document.getElementById('recover-form');

  // Function to open the account drawer and display the appropriate form
  function openAccountDrawer(showRecoverForm) {
    if (accountDrawer) {
      accountDrawer.classList.add('open');
    }

    if (loginForm && recoverForm) {
      if (showRecoverForm) {
        loginForm.style.display = 'none';
        recoverForm.style.display = 'block';
      } else {
        loginForm.style.display = 'block';
        recoverForm.style.display = 'none';
      }
    } else {
      console.error('Login form or recover form not found in the DOM.');
    }
  }

  // Function to handle hash changes
  function handleHashChange() {
    const hash = window.location.hash;
    if (hash === '#recover') {
      openAccountDrawer(true); // Show recover password form
    } else {
      // Optionally handle other hashes or default behavior
      // openAccountDrawer(false); // Show login form
    }
  }

  // Check the hash on page load
  handleHashChange();

  // Listen for hash changes
  window.addEventListener('hashchange', handleHashChange);

  // Event listener for desktop account button
  if (accountButtonDesktop) {
    accountButtonDesktop.addEventListener('click', function(event) {
      event.preventDefault();
      openAccountDrawer(false); // Show login form
    });
  }

  // Event listener for mobile account button
  if (accountButtonMobile) {
    accountButtonMobile.addEventListener('click', function(event) {
      event.preventDefault();
      openAccountDrawer(false); // Show login form
    });
  }

  // Close drawer on clicking close button
  if (closeButton) {
    closeButton.addEventListener('click', function(event) {
      event.preventDefault();
      if (accountDrawer) {
        accountDrawer.classList.remove('open');
        // Remove the hash from the URL
        history.pushState("", document.title, window.location.pathname + window.location.search);
      }
    });
  }

  // Optional: Close the drawer when clicking outside of it
  document.addEventListener('click', function(event) {
    if (
      accountDrawer &&
      accountDrawer.classList.contains('open') &&
      !accountDrawer.contains(event.target) &&
      !accountButtonDesktop.contains(event.target) &&
      !(accountButtonMobile && accountButtonMobile.contains(event.target))
    ) {
      accountDrawer.classList.remove('open');
      // Remove the hash from the URL
      history.pushState("", document.title, window.location.pathname + window.location.search);
    }
  });
});
